// import React from 'react'
import React, { useState, useContext } from "react";
import { Button, Box, Grid, Stack, TextField, Typography } from "@mui/material";
import { BrowserRouter as Router, Routes, Route, useNavigate, Navigate } from 'react-router-dom';
// import { AccountContext } from "./Account";
import { SnackbarOrigin, Snackbar } from "@mui/material";
import MuiAlert from '@mui/material/Alert';
import { configure } from "../../config";
// import { Axios } from "axios";
import axios from "axios";
 
 
const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
 
function ResetPassword() {
    const [stateMsg, setStateMsg] = React.useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
    });
    const { vertical, horizontal, open } = stateMsg;
    const [msg, setMsg] = useState("")
    const [severity, setSeverity] = useState("")
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [newPassword, setNewPassword] = useState("");
    let navigate = useNavigate();
    const messageBox = (severity, msg) => {
        setSeverity(severity)
        setMsg(msg)
        var newState = {
            vertical: 'top',
            horizontal: 'center',
        }
        setStateMsg({ open: true, ...newState });
    }
    const handleClose = () => {
        setStateMsg({ ...stateMsg, open: false });
    };
 
 
    const onSubmit = async () => {
        if (password.trim().length === 0 || newPassword.trim().length === 0) {
            return;
        }
 
        if (newPassword.length < 8) {
            messageBox("error", 'Password is too short. It must contain at least 8 characters.');
            return;
        }
     
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/;
        if (!passwordRegex.test(newPassword)) {
            messageBox("error", 'Password must contain at least one uppercase letter, one lowercase letter, one digit, and one special character.');
            return;
        }
 
        const data =JSON.stringify( {
            username:email,
            password: password,
            new_password: newPassword
        });
        try {
            const response = await fetch(`${configure.backendUrl}/login`, {
                method: 'POST',
                body: data
            });
            const responseData = await response.text();
            // const result = await response.json();
            if (responseData) {
                if (response.status === 200) {
                    const result = responseData;
                    messageBox("success", 'Password Changed Successfully!');
                    // navigate("/login");
                    setTimeout(() => {
                        navigate("/login");
                    }, 3000); // Adjust the delay time as needed
                } else {
                    const errorText = responseData || 'Something went wrong';
                    messageBox("error", errorText);
                }
            }

        } catch (error) {
            console.error("Unexcepted error:",error);
            messageBox("error",'Something went wrong');
        }
    };
 
  return (
    
    <div className="margin-bottom-15">
    <h3>Change Password</h3>
 
 
    <div>
    <Grid flex={3} p={1} sx={{ boxShadow: 0, marginRight: 1, maxHeight: 1 }}>
        <Stack direction={"column"} p={1} gap={1}>
            <Grid container sx={{ flexDirection: 'column', width: '40%' }} spacing={1}>
 
            <Grid item>
                    <Box sx={{ flexDirection: 'column' }}>
                        <Typography fontSize={15}>
                            Email
                        </Typography>
                        <TextField size="small" type={'email'} value={email} onChange={(e) => { setEmail(e.target.value) }} sx={{ width: '100%', color: '#e0e0e0', borderColor: 'gray.500' }} inputProps={{ style: { height: "15px", background:'#fff' } }}>
                        </TextField>
                        <label for="validationError" class="form-label text-danger">{email.trim().length == 0 ? " email is required" : ""}</label>
                    </Box>
                </Grid>
           
                <Grid item>
                    <Box sx={{ flexDirection: 'column' }}>
                        <Typography fontSize={15}>
                            Old Password
                        </Typography>
                        <TextField size="small" type={'password'} value={password} onChange={(e) => { setPassword(e.target.value) }} sx={{ width: '100%', color: '#e0e0e0' }} inputProps={{ style: { height: "15px", background:'#fff' } }}>
                        </TextField>
                        <label for="validationError" class="form-label text-danger">{password.trim().length == 0 ? "old password is required" : ""}</label>
                    </Box>
                </Grid>
                <Grid item>
                    <Box sx={{ flexDirection: 'column' }}>
                        <Typography fontSize={15}>
                            New Password
                        </Typography>
                        <TextField size="small" type={'password'} value={newPassword} onChange={(e) => { setNewPassword(e.target.value) }} sx={{ width: '100%' }} inputProps={{ style: { height: "15px", background:'#fff' } }}>
                        </TextField>
                        <label for="validationError" class="form-label text-danger">{newPassword.trim().length == 0 ? "new password is required" : ""}</label>
                    </Box>
                </Grid>
                <Grid item>
                    <Box display={'flex'} sx={{ justifyContent: 'flex-start' }}>
                        <Box display={'flex'} sx={{ width: 330, justifyContent: 'space-between' }}>
                            <Button size="small" variant="contained" color="success" onClick={onSubmit}  sx={{ width: 135 }}>Change Password</Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Stack>
    </Grid>
    <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        key={vertical + horizontal}
    >
        <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
            {msg}
        </Alert>
    </Snackbar>
</div>
</div>
 
  )
}
 
export default ResetPassword